<template>
  <div class="card" :class="{ 'is-minimized': isMinimized }">
    <header v-if="title" class="card-header">
      <p v-if="!isMinimized" class="card-header-title">
        <b-icon
          v-if="icon"
          :icon="icon"
          class="header-icon"
          custom-size="default"
        />
        <template>
          {{ title }}
        </template>
      </p>
      <span @click="onHeaderRightClick" class="card-header-icon has-text-dark">
        <slot name="headerRight" />
        <b-button
          v-if="hasBack"
          icon-left="chevron-left"
          size="is-small"
          @click="$router.back()"
        >
          Back
        </b-button>
      </span>
    </header>
    <div class="card-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardComponent',
  props: {
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    headerRightIcon: {
      type: String,
      default: null
    },
    isMinimized: {
      type: Boolean,
      default: false
    },
    hasBack: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onHeaderRightClick() {
      this.$emit('on-header-right-click')
    }
  }
}
</script>
